module.exports = __webpack_public_path__ + "img/gate_s.083aead0.png";